import { render, staticRenderFns } from "./ProductionRecordCertificate.vue?vue&type=template&id=0ba931b3&scoped=true"
import script from "./ProductionRecordCertificate.vue?vue&type=script&lang=js"
export * from "./ProductionRecordCertificate.vue?vue&type=script&lang=js"
import style0 from "./ProductionRecordCertificate.vue?vue&type=style&index=0&id=0ba931b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba931b3",
  null
  
)

export default component.exports